import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const THEME_MAP = {
  1: {
    themeKey: "cortisolDetox",
    block: "somatic",
  },
  2: {
    themeKey: "summerBody",
    block: "quiz",
  },
  3: {
    themeKey: "storedEmotions",
    block: "somatic",
  },
  4: {
    themeKey: "notExercised",
    block: "quiz",
  },
  5: {
    themeKey: "wallPilates",
    block: "quiz",
  },
};

const STORAGE_KEY = "selectedTheme";

export default function useThemeParam() {
  const result = useMemo(() => {
    const storedTheme = sessionStorage.getItem(STORAGE_KEY);
    if (storedTheme && THEME_MAP[storedTheme]) {
      return THEME_MAP[storedTheme];
    }

    return { themeKey: null, block: null };
  }, []);

  return {
    theme: result.themeKey,
    block: result.block,
    hasTheme: !!result.themeKey,
  };
}
